import { Stack, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import useSetTabTitle from "hooks/useSetTabTitle";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const title = "Вакансии";

  useSetTabTitle(title);

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      alignItems={{ xs: "flex-start", md: "center" }}
      justifyContent='space-between'
      sx={{ marginBottom: 2 }}>
      <Typography variant='h28'>{title}</Typography>
      <Stack
        spacing={2}
        direction='row'>
        <Button
          variant='contained'
          onClick={() => {
            navigate("create");
          }}>
          Создать вакансию
        </Button>
      </Stack>
    </Stack>
  );
};

export default Header;
